import { FC, ReactElement, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Prompt } from 'react-router';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import TextEditor from 'src/view/components/TextEditor/TextEditor';
import { IValidation } from '~/types/main';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import SettingControlsBlock from '~/view/screens/SettingsScreen/containers/SettingControlsBlock/SettingControlsBlock';
import './style.scss';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';

interface IProps {
  value: string | undefined;
  validation: IValidation;
  isLoading: boolean;
  isFirstLoading: boolean;
  isEdit: boolean;
  onChange: (value: string) => void;
  onSubmit: () => Promise<true | undefined>;
}

const WebsiteInfoWysiwyg: FC<IProps> = (props: IProps): ReactElement => {
  const updateTargetAttributes = (html: string): string => {
    return html.replace(/<a\s+([^>]*?)target=["']_self["']([^>]*?)>/gi, '<a $1target="_blank"$2>');
  };

  const onChange = useCallback((value: string) => {
    props.onChange(updateTargetAttributes(value));
  }, []);

  return (
    <ScrollableBlock showScrollbar scrollClassName="website-info-wysiwyg">
      {props.isFirstLoading || props.isLoading ? (
        <div className="d-flex flex-column gap-20">
          <Skeleton width={736} height={46} style={{ borderRadius: 12 }} />
          <Skeleton width="100%" height={426} style={{ borderRadius: 12 }} />
        </div>
      ) : (
        <TextEditor value={props.value} onChange={onChange} validation={props.validation} />
      )}

      <SettingControlsBlock onSubmit={props.onSubmit} />

      <LoadingOverlay visible={props.isLoading} />
      <Prompt when={props.isEdit} message={getPromptProps()} />
    </ScrollableBlock>
  );
};

export default WebsiteInfoWysiwyg;
